// Shared classes for the Account page cards (Figma "Account", 10596:336).

export const accountSectionClassName =
  'rounded-section border border-grey-100 bg-true-white dark:border-border dark:bg-card';

export const accountSectionTitleClassName =
  'text-base font-medium leading-heading text-grey-950 dark:text-foreground';

export const accountOutlineButtonClassName =
  'h-10 shrink-0 rounded-full border border-grey-200 bg-true-white px-4 text-sm font-medium leading-body text-grey-950 hover:bg-grey-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-border dark:bg-card dark:text-foreground dark:hover:bg-muted';

export const accountFieldClassName =
  'flex h-11 w-full items-center rounded-xl border border-grey-100 bg-true-white px-3 text-sm text-grey-950 dark:border-border dark:bg-card dark:text-foreground';

export const accountBadgeClassName =
  'shrink-0 rounded-full px-2.5 py-0.5 text-xs font-medium leading-heading';

export const accountPrimaryButtonClassName =
  'h-10 shrink-0 rounded-full bg-grey-950 px-4 text-sm font-medium leading-body text-true-white hover:bg-grey-900 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-foreground dark:text-background dark:hover:bg-foreground/90';

export const accountGhostButtonClassName =
  'h-10 shrink-0 rounded-full px-3 text-sm font-medium leading-body text-grey-600 hover:bg-grey-50 disabled:cursor-not-allowed disabled:opacity-50 dark:text-muted-foreground dark:hover:bg-muted';
